import React from "react";
import MainLayout from "../MainLayout";

function MainLayoutNoNavbar(props) {
  return (
    <MainLayout noNavbar={true} {...props}>
      {props.children}
    </MainLayout>
  );
}

export default MainLayoutNoNavbar;



// WEBPACK FOOTER //
// ./src/util/Layouts/MainLayoutNoNavbar/index.js